import React, {useMemo} from "react";
import {twJoin} from "tailwind-merge";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";
import {ProductSelectionOption} from "@/data/entities/cart";
import {getFormattedProductPrice, getProductPrice} from "@/utils/MoneyUtils";
import {FormattedMessage} from "react-intl";

type Props = {
    option: ProductSelectionOption,
};

const PriceIndicator = ({option}: Props) => {
    const fulfillmentType = useFulfillmentType();
    const productPrice: string = useMemo(
        () => getProductPrice(option, fulfillmentType),
        [option, fulfillmentType]);
    const isFree: boolean = useMemo(
        () => Number(productPrice) === 0,
        [productPrice]);

    return (
        <data
            className={twJoin(
                "font-medium whitespace-nowrap",
                isFree
                    ? "text-green-700 dark:text-green-400"
                    : "text-gray-600 dark:text-gray-200",
            )}
        >
            {
                isFree
                    ? <FormattedMessage id={"free"}/>
                    : <FormattedMessage
                        id={Number(productPrice) >= 0 ? "plus-price" : "minus-price"}
                        values={{price: getFormattedProductPrice(option, fulfillmentType)}}
                    />
            }
        </data>
    );
};

export default PriceIndicator;